import { useFormContext, useWatch } from "react-hook-form";
import { Stack, Typography } from "@mui/material";

import { ConditionData, YesNo } from "@covertree/types";

import { UnderwritingQuestionsForm } from "../../validatorsAndTypes/underwritingQuestions";

interface PerilNote {
  readonly text: string;
  readonly answers: (keyof UnderwritingQuestionsForm)[];
}

function PerilNoteText({ text, answers }: PerilNote) {
  const { control } = useFormContext<UnderwritingQuestionsForm>();
  const values = useWatch({ control, name: answers });

  if (!values.every((value) => value === YesNo.Yes)) {
    return null;
  }

  return (
    <Typography variant="body2" color="secondary">
      {text}
    </Typography>
  );
}

/** Adds the note under the card's content describing the added peril based of an uw answer. */
export function withPerilNote(
  note: PerilNote,
  getContent?: ConditionData["getContent"]
): ConditionData["getContent"] {
  return function PerilNoteContent(cardName, onClick, hidden) {
    if (hidden) {
      return undefined;
    }

    return (
      <Stack spacing={1} alignItems="flex-start">
        {getContent?.(cardName, onClick, hidden)}
        <PerilNoteText {...note} />
      </Stack>
    );
  };
}
